import { GzLandingPageProductLinks } from '../../../../common/gzLandingPage/view/gzLandingPageConfig/gz-landing-page-links';
import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';
import {
  InProductTrialsOverlayWindowReadyToTryType,
  InProductTrialsOverlayWindowTrialEndedType,
  InProductTrialsOverlayWindowType,
} from '../../types/InProductTrialsOverlayWindowType';

export const InProductTrialsOverlayWindowLinks: {
  [type in InProductTrialsOverlayWindowReadyToTryType | InProductTrialsOverlayWindowTrialEndedType]: string;
} = {
  // ready to try
  [InProductTrialsOverlayWindowType.OfficeSecurityPackReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.OfficeSecurityPack].link,
  [InProductTrialsOverlayWindowType.NextGenIncidentsReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.NextGen].link,
  [InProductTrialsOverlayWindowType.NextGenWithReconfigureReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.NextGenWithReconfigurePopup].link,
  [InProductTrialsOverlayWindowType.AtdIncidentsReadyToTry]: GzLandingPageProductLinks[InProductTrialTypeEnum.Atd].link,
  [InProductTrialsOverlayWindowType.PatchManagementNetworkReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.PatchManagement].link,
  [InProductTrialsOverlayWindowType.VolumeEncryptionNetworkReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.VolumeEncryption].link,
  [InProductTrialsOverlayWindowType.MobileSecurityMobileReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.MobileSecurity].link,
  [InProductTrialsOverlayWindowType.IntegrityMonitorReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.IntegrityMonitor].link,
  [InProductTrialsOverlayWindowType.ContainerProtectionReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.ContainerProtection].link,
  [InProductTrialsOverlayWindowType.StorageProtectionReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.StorageProtection].link,
  [InProductTrialsOverlayWindowType.XdrFullReadyToTry]: GzLandingPageProductLinks[InProductTrialTypeEnum.XdrFull].link,
  [InProductTrialsOverlayWindowType.XdrSensorsReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.XdrSensors].link,
  [InProductTrialsOverlayWindowType.NadAndEraReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.NadAndEraAddon].link,
  [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlReadyToTry]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.WebAccessAndDeviceControlAddon].link,

  // trial ended
  [InProductTrialsOverlayWindowType.OfficeSecurityPackTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.OfficeSecurityPack].link,
  [InProductTrialsOverlayWindowType.NextGenTrialEnded]: GzLandingPageProductLinks[InProductTrialTypeEnum.NextGen].link,
  [InProductTrialsOverlayWindowType.NextGenWithReconfigureTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.NextGenWithReconfigurePopup].link,
  [InProductTrialsOverlayWindowType.AtdTrialEnded]: GzLandingPageProductLinks[InProductTrialTypeEnum.Atd].link,
  [InProductTrialsOverlayWindowType.PatchManagementTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.PatchManagement].link,
  [InProductTrialsOverlayWindowType.VolumeEncryptionTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.VolumeEncryption].link,
  [InProductTrialsOverlayWindowType.MobileSecurityTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.MobileSecurity].link,
  [InProductTrialsOverlayWindowType.IntegrityMonitorTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.IntegrityMonitor].link,
  [InProductTrialsOverlayWindowType.ContainerProtectionTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.ContainerProtection].link,
  [InProductTrialsOverlayWindowType.StorageProtectionTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.StorageProtection].link,
  [InProductTrialsOverlayWindowType.XdrFullTrialEnded]: GzLandingPageProductLinks[InProductTrialTypeEnum.XdrFull].link,
  [InProductTrialsOverlayWindowType.XdrSensorsTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.XdrSensors].link,
  [InProductTrialsOverlayWindowType.NadAndEraTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.NadAndEraAddon].link,
  [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlTrialEnded]:
    GzLandingPageProductLinks[InProductTrialTypeEnum.WebAccessAndDeviceControlAddon].link,
};
